import { render, staticRenderFns } from "./MerchantRegister.vue?vue&type=template&id=44d08b80&"
import script from "./MerchantRegister.vue?vue&type=script&lang=js&"
export * from "./MerchantRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports